import React, { useState, useEffect } from "react";

function getRemaining(target) {
  const diff = new Date(target).getTime() - Date.now();
  const clamped = Math.max(diff, 0);
  const days = Math.floor(clamped / (1000 * 60 * 60 * 24));
  const hours = Math.floor((clamped / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((clamped / (1000 * 60)) % 60);
  const seconds = Math.floor((clamped / 1000) % 60);
  return { days, hours, minutes, seconds, done: diff <= 0 };
}

const pad = (n) => String(n).padStart(2, "0");

const Countdown = ({ target = "2027-12-04T16:00:00-04:00" }) => {
  const [t, setT] = useState(getRemaining(target));

  useEffect(() => {
    const id = setInterval(() => setT(getRemaining(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  const units = [
    { label: "Days", value: t.days },
    { label: "Hours", value: pad(t.hours) },
    { label: "Minutes", value: pad(t.minutes) },
    { label: "Seconds", value: pad(t.seconds) },
  ];

  return (
    <div className="inline-block">
      <p className="font-cond uppercase tracking-[0.35em] text-white/60 text-xs mb-3">
        {t.done ? "We Have Set Sail!" : "Countdown To Sail-Away"}
      </p>
      <div className="flex items-stretch gap-2 sm:gap-3">
        {units.map((u, i) => (
          <React.Fragment key={u.label}>
            <div className="flex flex-col items-center bg-[#111111]/80 backdrop-blur-sm border border-white/10 rounded-xl min-w-[64px] sm:min-w-[80px] px-2 py-3">
              <span className="font-display text-white text-3xl sm:text-4xl leading-none tabular-nums">
                {u.value}
              </span>
              <span className="font-cond uppercase text-[var(--hh-gold)] text-[10px] tracking-widest mt-1.5">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && (
              <span className="font-display text-[#E50914] text-3xl sm:text-4xl self-center">:</span>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Countdown;
